import type { EnDictionary } from './en';
import { eoZh } from './eo';
import { profileZh } from './profile';

export const zh: EnDictionary = {
  'common.loading': '加载中…',
  'common.signIn': '登录',
  'common.signOut': '退出登录',
  'common.signUp': '注册',
  'common.continue': '继续',
  'common.back': '返回',
  'common.cancel': '取消',
  'common.submit': '提交',
  'common.email': '邮箱',
  'common.password': '密码',
  'common.confirmPassword': '确认密码',
  'common.fullName': '姓名',
  'common.phone': '电话',
  'common.companyName': '公司名称',
  'common.required': '必填',
  'common.errorBoundary.title': '出了点问题',
  'common.errorBoundary.message': '页面遇到意外错误，请重新加载后再试。',
  'common.errorBoundary.reload': '重新加载',

  'marketing.eyebrow': '健康 · 运动 · 文化',
  'marketing.heroTitle': '在意大利, 体验 Wellness, Sport 与 Cultura',
  'marketing.heroSub':
    '在海滨, 古镇与山脉之间的标志性地点, 为个人, 团队与企业打造能量再生的转化型体验.',
  'marketing.requestProposal': '索取方案',
  'marketing.exploreExperiences': '探索体验',
  'marketing.pillarsTitle': '再生, 运动 与 文化',
  'marketing.pillarsSub':
    '与场所与专业人士共同设计的项目, 为个人, 团队与宾客带来切实的福祉.',
  'marketing.pillar.regenerationTitle': '再生',
  'marketing.pillar.regenerationDesc':
    '通过正念, 瑜伽, 呼吸训练与倾听, 减压并改善平衡与健康的路径.',
  'marketing.pillar.sportTitle': '运动 与 自然',
  'marketing.pillar.sportDesc':
    '在海滨, 湖区与山间, 体验 SUP, 徒步, 瑜伽等新兴运动.',
  'marketing.pillar.cultureTitle': '文化 与 美食',
  'marketing.pillar.cultureDesc':
    '与精选的导览, 工匠与本地伙伴一同沉浸于本地遗产, 艺术与正宗风味.',
  'marketing.trustTitle': '信任与影响',
  'marketing.trustSub':
    '基于循证方法与清晰商业目标的项目设计, 服务于福祉与组织绩效.',

  'login.title': '登录',
  'login.subtitle': '使用邮箱和密码登录',
  'login.failed': '登录失败',
  'login.signingIn': '正在登录…',
  'login.noAccount': '还没有账号?',

  'signup.title': '注册',
  'signup.subtitle': '通过三步引导完成注册',
  'signup.step1Title': '个人信息',
  'signup.step2Title': '公司信息',
  'signup.step3Title': '确认',
  'signup.step1Desc': '填写基本信息以开始.',
  'signup.step2Desc': '介绍你的公司并选择角色.',
  'signup.step3Desc': '在创建账号前确认你的信息.',
  'signup.companyRole': '公司角色',
  'signup.create': '创建账号',
  'signup.creating': '正在注册…',
  'signup.failed': '注册失败',
  'signup.haveAccount': '已有账号?',
  'signup.role.customer': '客户',
  'signup.role.customerDesc': '寻找并购买适合团队的体验包.',
  'signup.role.travelAgency': '旅行社',
  'signup.role.travelAgencyDesc': '组织活动并发布整合方案.',
  'signup.role.eventOrganizer': '活动策划',
  'signup.role.eventOrganizerDesc': '创建与管理活动包模板.',
  'signup.role.facilityProvider': '场地方',
  'signup.role.facilityProviderDesc': '提供场地, 住宿与配套设施.',
  'signup.role.serviceProvider': '服务方',
  'signup.role.serviceProviderDesc': '提供导览, 健康, 物流等服务.',
  'signup.role.researchPartner': '研究伙伴',
  'signup.role.researchPartnerDesc': '提供测量, 分析与报告服务.',

  'authAction.verifying': '正在验证您的邮箱…',
  'authAction.successTitle': '邮箱验证成功！',
  'authAction.successDesc': '您的账号已激活，正在跳转至工作台…',
  'authAction.expiredTitle': '链接已过期',
  'authAction.expiredDesc': '此验证链接已过期，请重新申请。',
  'authAction.invalidTitle': '无效链接',
  'authAction.invalidDesc': '此验证链接无效或已被使用。',
  'authAction.errorTitle': '验证失败',
  'authAction.errorDesc': '操作失败，请重试。',
  'authAction.unsupportedTitle': '不支持的操作',
  'authAction.unsupportedDesc': '此链接类型暂不支持。',
  'authAction.goToLogin': '返回登录',
  'authAction.resendLink': '重新申请验证邮件',

  'verifyEmail.title': '请查看您的邮箱',
  'verifyEmail.desc': '我们已将验证链接发送至',
  'verifyEmail.desc2': '请点击邮件中的链接激活账号，完成后返回此处。',
  'verifyEmail.resend': '重新发送验证邮件',
  'verifyEmail.resending': '发送中…',
  'verifyEmail.resendSuccess': '验证邮件已发送，请查收。',
  'verifyEmail.resendError': '发送失败，请重试。',
  'verifyEmail.checkVerified': '我已完成邮箱验证',
  'verifyEmail.checking': '验证中…',
  'verifyEmail.notYetVerified': '邮箱尚未验证，请点击邮件中的链接。',
  'verifyEmail.backToLogin': '退出并返回登录',

  'dashboard.title': '我的工作台',
  'dashboard.welcome': '欢迎回来',
  'dashboard.stats.activeProposals': '进行中的方案',
  'dashboard.stats.confirmedBookings': '已确认预订',
  'dashboard.stats.upcomingRetreats': '即将开始的活动',
  'dashboard.stats.savedPackages': '收藏的体验包',
  'dashboard.quickActionsTitle': '快捷操作',
  'dashboard.action.companyProfile': '公司资料',

  'admin.login.title': '管理控制台',
  'admin.login.subtitle': '登录 N-Excelsior 管理控制台.',
  'admin.login.failed': '登录失败',
  'admin.login.forbidden': '该账号无权访问管理控制台.',
  'admin.changePassword.title': '设置新密码',
  'admin.changePassword.subtitle': '出于安全, 请在继续前修改初始密码.',
  'admin.changePassword.current': '当前密码',
  'admin.changePassword.new': '新密码',
  'admin.changePassword.confirm': '确认新密码',
  'admin.changePassword.submit': '更新密码',
  'admin.changePassword.submitting': '更新中…',
  'admin.changePassword.tooShort': '密码至少需要 10 位.',
  'admin.changePassword.forbidden': '请使用与默认密码不同的密码.',
  'admin.changePassword.mismatch': '两次输入的密码不一致.',
  'admin.changePassword.sameAsCurrent': '新密码必须与当前密码不同.',
  'admin.changePassword.currentRequired': '请输入当前密码.',
  'admin.dashboard.title': '管理工作台',
  'admin.dashboard.subtitle': 'N-Excelsior 平台的运营总览.',
  'admin.dashboard.kpi.users': '用户总数',
  'admin.dashboard.kpi.companies': '公司数',
  'admin.dashboard.kpi.pending': '待审核',
  'admin.dashboard.kpi.reports': '报告',
  'admin.dashboard.recentTitle': '最近注册',
  'admin.nav.users': '用户',
  'admin.nav.companies': '公司',
  'admin.nav.operators': '运营人员',
  'admin.nav.audit': '审计日志',

  ...eoZh,
  ...profileZh,
};
